import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Pagination from "../../CommonUI/Pagination/Pagination";
import './Dividenddetails.css';
import { format, parseISO } from 'date-fns';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'


function Dividenddetails() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [CategoryDividend, setCategoryDividend] = useState('5946');
    const [ShemeDividend, setShemeDividend] = useState('26');
    const [ShemeCodeDividend, setShemeCodeDividend] = useState('26');
    const [DataMfHoldingdropFundDivi, setDataMfHoldingdropFundDivi] = useState([]);
    const [DataMfHoldingdropCatDivi, setDataMfHoldingdropCatDivi] = useState([]);
    const [DataMfHoldingdropShemeDivi, setDataMfHoldingdropShemeDivi] = useState([]);
    const [DataMfHoldingDividend, setDataMfHoldingDividend] = useState([]);
    const [valuebtn, setValueBtn] = useState("-");
    const [DateDividend, setDateDividend] = useState("-");
    const [loadingshow, setloadingshow] = useState(false);
    const [DateDividenddrop, setDateDividenddrop] = useState([]);
    const [valuecategory, setValuecategory] = useState([]);
    const [valuecategory1, setValuecategory1] = useState([]);
    const [valuecategory2, setValuecategory2] = useState([]);

    // const [DateDividend, setDataMfHoldingdropDate] = useState("-");
    let getDataHoldingdropFundDivi, getDataHoldingdropCatDivi, getDataHoldingDividend, getDataHoldingdropDate;
    let PageSize = 5;
    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrlMfTopHoldingDividend = BaseURL + "MfDividend";
        fetch(`${getUrlMfTopHoldingDividend}/${DateDividend}/-/${ShemeDividend}/${CategoryDividend}/-/10/-`)
            .then((response) => response.json())
            .then((dataMHoldingdDivided) => {
                getDataHoldingDividend = dataMHoldingdDivided.data;
                setDataMfHoldingDividend(getDataHoldingDividend);
                var codename = getDataHoldingdropCatDivi[0].VCLASS;
                setValuecategory1(codename)
                setloadingshow(false);
                // console.log(getDataHoldingDividend, "MfDividend")
            })
            .catch((error) => {
            });
        const getUrlMfTopHoldingDropDividend = BaseURL + "MfHoldingDrop";


        fetch(`${getUrlMfTopHoldingDropDividend}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropFund) => {
                getDataHoldingdropFundDivi = dataMHoldingdropFund.data;
                setDataMfHoldingdropFundDivi(getDataHoldingdropFundDivi);
                var codename = getDataHoldingdropFundDivi[0].co_name;
                setValuecategory(codename)
                setloadingshow(false);
                // console.log(getDataHoldingdropFundDivi, "getDataHoldingdropFundDivi")
            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDropDividend}/${CategoryDividend}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropCat) => {
                getDataHoldingdropCatDivi = dataMHoldingdropCat.data;
                setDataMfHoldingdropCatDivi(getDataHoldingdropCatDivi);
                var codename = getDataHoldingdropCatDivi[0].VCLASS;
                setValuecategory1(codename)
                setloadingshow(false);
                // console.log(getDataHoldingdropCatDivi, "getDataHoldingdropCatDivi")
            })
            .catch((error) => {
            });

        const getUrlMfTopHoldingDate = BaseURL + "MfDateDividend";

        fetch(`${getUrlMfTopHoldingDate}`)
            .then((response) => response.json())
            .then((dataMHoldingdropDate) => {
                getDataHoldingdropDate = dataMHoldingdropDate.data;
                setDateDividenddrop(getDataHoldingdropDate);
                var codename = getDataHoldingdropDate[0].DivDate;
                setValuecategory2(codename)
                setloadingshow(false);
                // console.log(getDataHoldingdropDate, "getDataHoldingdropDate")
            })
            .catch((error) => {
            });

    }, [CategoryDividend, ShemeDividend, ShemeCodeDividend, valuebtn, DateDividend])

    const currentTableData = useMemo(() => {
        if (DataMfHoldingDividend != null && DataMfHoldingDividend != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (DataMfHoldingDividend != null && DataMfHoldingDividend != []) {
                if (DataMfHoldingDividend.length > 0) {
                    return DataMfHoldingDividend.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, DataMfHoldingDividend]);

    const routeChange = (paramname) => {
        window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
    }


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Dividend Details</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='dividendetail-loser-sc'>
                            <div className='dividendetail-header'>
                                <h2><span>Dividend Details</span></h2>
                            </div>
                            <MarketMF optionValue="Dividend details" />
                            <div className='dividendetail-right'>
                                <div className='dividendetail-inner-select'>
                                    
                                    {/* aria-label="Select Fund House" */}
                                    <select aria-label="Select Fund House" onChange={(event) => setCategoryDividend(event.target.value)}>
                                        <option>Select Fund House</option>
                                        {DataMfHoldingdropFundDivi && DataMfHoldingdropFundDivi.map(
                                            ({ mf_cocode, co_name }) => (
                                                <option value={mf_cocode} selected={valuecategory === co_name}>{co_name}</option>
                                            )
                                        )}
                                    </select>
                                </div>

                                <div className='dividendetail-inner-select'>
                                    
                                    {/* aria-label="Select Category" */}
                                    <select aria-label="Select Category" onChange={(event) => setShemeDividend(event.target.value)}>
                                        <option>Select Category</option>
                                        {DataMfHoldingdropCatDivi && DataMfHoldingdropCatDivi.map(
                                            ({ VCLASSCODE, VCLASS }) => (
                                                <option value={VCLASSCODE} selected={valuecategory1 === VCLASS}>{VCLASS}</option>
                                            )
                                        )}
                                    </select>
                                </div>

                                {/* aria-label="Select Date"  */}
                                <div className='dividendetail-inner-select'>
                                    <select aria-label="Select Date" onChange={(event) => setDateDividend(event.target.value)}>
                                        <option>Select Date</option>
                                        {DateDividenddrop && DateDividenddrop.map(
                                            ({ DivDate }) => (

                                                <option value={DivDate} selected={valuecategory2 === DivDate}>{DivDate}</option>

                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='dividendetail-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-right'>Nav(&#8377;)</th>
                                            <th className='text-right'>Dividend(%)</th>
                                            <th className='text-right'>Record Date</th>
                                            <th className='text-right'>1 Year(%)</th>
                                            <th className='text-right'>3 Year(%)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ MF_SCHCODE, Sch_Name, NAVRS, DivPer, RecordDate, year1, year3 }) => (
                                                <tr>
                                                    <td className='text-left'><h6 onClick={() => routeChange(Sch_Name)} tabIndex={0} >{Sch_Name}</h6></td>
                                                    <td className='text-right'>{NAVRS}</td>
                                                    <td className='text-right'>{DivPer.toFixed(2)}</td>
                                                    <td className="text-right">{(RecordDate != null) ? (format(parseISO(RecordDate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className='text-right'>{year1.toFixed(2)}</td>
                                                    <td className='text-right'>{(year3 != null) ? year3.toFixed(2) : 0}</td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>
                            {(DataMfHoldingDividend != null && DataMfHoldingDividend != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(DataMfHoldingDividend.length != null) ? DataMfHoldingDividend.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}


export default Dividenddetails;